import { Component, OnInit } from '@angular/core';
import {
  hideSpinner,
  showSpinner,
} from 'src/app/core/services/functions.service';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { VisorService } from '../../services/Diagnosticadorvisor.service';

@Component({
  selector: 'app-diagnosticador-visor',
  templateUrl: './diagnosticador-visor.component.html',
  styleUrls: ['./diagnosticador-visor.component.scss'],
})
export class DiagnosticadorVisorComponent implements OnInit {
  docs: any;
  doc_selected: any;
  n_ide: any;
  result: any;
  data: any = {
    primer_nombre: '',
    primer_apellido: '',
    correo: '',
    celular: '',
    ingresos: '',
  };
  mostrar: string;
  constructor(
    private _VisorService: VisorService,
    private helpers: HelpersService
  ) { }

  ngOnInit(): void {
    this.tipo_docs();
  }
  modo_c = async (cedula, tipo_doc) => {
    showSpinner();
    cedula && (this.result = await this._VisorService.modo_c(tipo_doc, cedula));
    if (!this.result.success) {
      this.helpers.notifications.warningMessage(this.result.data.msn_error);
    } else {
      this.result = this.result.data;
      this.data.primer_nombre = this.result.primer_nombre;
      this.data.primer_apellido = this.result.primer_apellido;

      this.data.celular = this.result.celular;
      this.data.ingresos = this.result.ingresos;
      if (this.result.salida == 'CONOCIDO') {
        this.mostrar = 'detalle';
      } else {
        this.mostrar = 'eveluar';
      }
    }
    hideSpinner();
  };

  tipo_docs = async () => {
    let result: any = await this._VisorService.documents_types();
    this.docs = result['data'];
    this.doc_selected = 'CC';
  };
  modo_e = async () => {
    showSpinner();

    let body = {
      primer_nombre: this.data.primer_nombre,
      primer_apellido: this.data.primer_apellido,
      actividad_cargo: '',
      ocupacion: '1',
      celular: '' + this.data.celular + '',
      ingresos: '' + this.data.ingresos + '',
      correo: this.data.correo,
      tipo_doc: this.doc_selected,
      sector_trabajo: '',
      agencia_seleccionada: this.result.c_agr,
      canal_venta: 'distancia',
      internal_id: this.result.internal_id,
      agency: this.result.c_agr,
      vendedor: this.result.usuario,
      usuario: this.result.usuario,
      programa: this.result.programa,
    };
    let data: any = await this._VisorService.modo_e(body, this.n_ide);
    if (data.success) {
      if (
        data.data.msn_error != ''
      ) {
        hideSpinner();
        this.helpers.notifications.errorMessage(data.data.msn_error);
      } else {
        hideSpinner();
        this.data = data.data;
        this.mostrar = 'detalle';
      }
    } else {
      hideSpinner();
      this.helpers.notifications.errorMessage(data.message);
    }
  };
}
